export const DASHBOARD = "/dashboard";
export const GOALS = "/goals";
export const BUDDY_FINDER = "/buddy-finder";
export const EVENTS = "/events";
export const MESSAGES = "/messages";
export const COMMUNITY = "/community";
export const PADDIE_PODS = "/pods";
export const MILESTONES = "/milestones";
export const PROFILE = "/profile";
export const SETTINGS = "/settings";

export const BACKEND_BASE_URL = "";
